var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{staticClass:"filters-btn",attrs:{"color":"black","icon":"plus","data-testid":"filter-btn"}},[_vm._v(_vm._s(_vm.$t('global.filter')))])
}
var staticRenderFns = []

export { render, staticRenderFns }